+function ($) {
	'use strict';
	
	// # Dismissable class
	var dismissable = '[data-dismissable="close"], [data-dismissable="remove"]',
		animationSpeed = 400;
	
	// # Dismissable function
	$(document).on('click', dismissable, function (e) {
		var $this = $(e.currentTarget),
			dismissableTarget = $this.attr('data-target'),
			dismissableItem = $(dismissableTarget);
		
		// If there is no applicable target find closest applicable target with class 'rocDismissable'
		if (!dismissableItem.length) {
			dismissableItem = $this.closest('.roc-dismissable');
		}
		
		// fire event immediately when the dismiss method is called
		dismissableItem.trigger(e = $.Event('close.roc.dismissable'));
		
		// check to see if default function should be prevented
		if (e.isDefaultPrevented()) {
			return;
		}
		
		dismissableItem.addClass('roc-dismissing');

		setTimeout(function () {		
			if (($this.attr('data-dismissable') === 'close') && dismissableItem.hasClass('roc-dismissing')) {
				// fire event and apply classes
				dismissableItem.trigger('closed.roc.dismissable').removeClass('roc-dismissing').addClass('roc-dismissed');
			} else if (($this.attr('data-dismissable') === 'remove') && dismissableItem.hasClass('roc-dismissing')) {
				// detach, fire event and cleanup
				dismissableItem.detach().trigger('closed.roc.dismissable').remove();
			}
		}, animationSpeed);
	});

}(jQuery);
define("plugins/dismissable", ["jquery"], function(){});

